// based on: https://dev.to/ferdiesletering/how-to-implement-an-inline-styles-content-security-policy-with-angular-and-nginx-2ke2

import { NgModule } from '@angular/core';
import { CustomDomSharedStylesHost } from './classes/shared_styles_host';
import { ɵDomSharedStylesHost } from '@angular/platform-browser';

@NgModule({
	providers: [{ provide: ɵDomSharedStylesHost, useClass: CustomDomSharedStylesHost }],
})
export class InlineStylesCSPModule {}
